// extracted by mini-css-extract-plugin
module.exports = {"featured":"Featured_featured__1M4p6","featured__logos":"Featured_featured__logos__3ZlSx"};